import { useState } from 'react';
import { Container } from 'react-bootstrap';

import { Upload } from '../FormFields/Upload';
import { ControlButtons } from '../ControlButtons';

export const UTPyroLicense = ({
	currLicense = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) => {
	const [currFile, setCurrFile] = useState(currLicense.file);
	const [currAnswer, setCurrAnswer] = useState(currLicense.answer);

	return (
		<>
			<Container className="mt-5 component">
				<h2 className="mb-4">
					Do you have your Utah State Pyrotechnic Operator License?
				</h2>
				<p>
					If you don't upload your Pyrotechnic Operater Licence in your
					application, you must come bring one in person.
				</p>
				<Upload
					file={currFile}
					setFile={setCurrFile}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<Container>
				<ControlButtons
					onSubmit={() => onSubmit({ file: currFile, answer: currAnswer })}
					onNext={() => onNext({ file: currFile, answer: currAnswer })}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={currAnswer === null || (currAnswer && !currFile)}
					disablePrev={disablePrev}
					enableLoading={enableLoading}
				/>
			</Container>
		</>
	);
};
